import React from 'react'
import axios from 'axios'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import 'dotenv/config'
import { Root } from './components/App/Root'
import './i18n'
import 'antd/dist/antd.css'
import './index.css'
import { getAccessToken } from './utils/token'
import accessEnv from './utils/AccessEnv'

const REMOTE_SERVICE_URL =
  window.location.origin === 'http://localhost:5000'
    ? accessEnv('REACT_APP_REMOTE_SERVICE_URL', 'http://localhost')
    : `${window.location.origin}/api`

axios.defaults.baseURL = `${REMOTE_SERVICE_URL}`
axios.defaults.headers = {
  Authorization: `Bearer ${getAccessToken()}`
}
// axios.defaults.baseURL = 'http://localhost:7000'
axios.defaults.withCredentials = true

ReactDOM.render(<Root />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
